// src/pages/admin/EditUser.js
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import { Box } from "../../../components/elements";
import { Button as MuiButton } from '@mui/material';
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { useNavigate, useParams, Link } from "react-router-dom";

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [user, setUser] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    phone: "",
    role: "1",
    access_level: [],     // ← new
  });

  // When role changes, default access_level
  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    setUser({
      ...user,
      role: newRole,
      access_level:
        newRole === "1" ? ["ITEMS_MODULE"] : ["ORDERS_MODULE"],
    });
  };

  // fetch current user data
  useEffect(() => {
    const loadUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}admin/get-user/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const u = res.data.user;
        setUser({
          name: u.name,
          username: u.username,
          email: u.email,
          password: "", // leave blank unless changing
          phone: u.phone || "",
          role: String(u.role),
          access_level:
            Array.isArray(u.access_level) && u.access_level.length
              ? u.access_level
              : u.role === 1
              ? ["ITEMS_MODULE"]
              : ["ORDERS_MODULE"],
        });
      } catch (err) {
        alert("Failed to load user");
        navigate("/users-list");
      }
    };
    loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const updateUser = async () => {
    const { name, email, role, access_level } = user;
    if (!name || !email || !role) {
      alert("Name, Email, and Role are required.");
      return;
    }

    // build payload
    const payload = { ...user };
    if (!payload.password) delete payload.password;

    try {
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}admin/update-user/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("User updated successfully!");
      navigate("/users-list");
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Update failed");
    }
  };

  return (
    <PageLayout>
      <Grid container spacing={2}>
        <Grid
          size={{ xs: 12 }}
          className="d-flex justify-content-between align-items-center"
        >
          <Breadcrumb title="Edit User" />
          <Link to="/users-list">
            <MuiButton variant="contained" color="primary">Back to Users List</MuiButton>
          </Link>
        </Grid>

        <Grid size={{ xs: 12 }} className="mt-3">
          <Box className="mc-card">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
                <CardHeader title="Name" />
                <TextField
                  fullWidth
                  value={user.name}
                  onChange={(e) =>
                    setUser({ ...user, name: e.target.value })
                  }
                />
              </Grid>
              <Grid>
                <CardHeader title="Username" />
                <TextField
                  fullWidth
                  value={user.username}
                  onChange={(e) =>
                    setUser({ ...user, username: e.target.value })
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
                <CardHeader title="Email" />
                <TextField
                  type="email"
                  fullWidth
                  value={user.email}
                  onChange={(e) =>
                    setUser({ ...user, email: e.target.value })
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
                <CardHeader title="Password (leave blank to keep)" />
                <TextField
                  type="password"
                  fullWidth
                  value={user.password}
                  onChange={(e) =>
                    setUser({ ...user, password: e.target.value })
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
                <CardHeader title="Phone" />
                <TextField
                  type="tel"
                  fullWidth
                  value={user.phone}
                  onChange={(e) =>
                    setUser({ ...user, phone: e.target.value })
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
                <CardHeader title="Role" />
                <TextField
                  select
                  fullWidth
                  value={user.role}
                  onChange={handleRoleChange}
                >
                  <MenuItem value="1">User</MenuItem>
                  <MenuItem value="2">Plant Foreman</MenuItem>
                </TextField>
              </Grid>

              {/* New Access Level Multiselect */}
              <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
                <CardHeader title="Access Level" />
                <TextField
                  select
                  fullWidth
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.join(", "),
                  }}
                  value={user.access_level}
                  onChange={(e) =>
                    setUser({ ...user, access_level: e.target.value })
                  }
                >
                  <MenuItem value="ITEMS_MODULE">
                    Items Module
                  </MenuItem>
                  <MenuItem value="ORDERS_MODULE">
                    Orders Module
                  </MenuItem>
                  <MenuItem value="JOBS_MODULE">
                    Jobs Module
                  </MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <div className="mt-4 d-flex justify-content-end">
              <MuiButton variant="contained" color="primary" onClick={updateUser}>
                Save Changes
              </MuiButton>
            </div>
          </Box>
        </Grid>
      </Grid>
    </PageLayout>
  );
}
